import React from "react";

export default function AssessmentQuestion(
{
    title,
    value,
    options,
    setValue
})
{
    const selectedIndex =
        options.findIndex(
            function(option)
            {
                return option.label === value;
            }
        );

    const segmentWidth =
        100 / options.length;

    const selectedOption =
        options[selectedIndex];

    return (

        <div style={container}>

            <div style={titleStyle}>
                {title}
            </div>

            <div style={scaleContainer}>

                {
                    options.map(
                        function(option, index)
                        {
                            return (

                                <div
                                    key={option.label}
                                    style={{
                                        ...segment,

                                        background:
                                            option.gradient,

                                        borderTopLeftRadius:
                                            index === 0
                                            ?
                                            "22px"
                                            :
                                            "0px",

                                        borderBottomLeftRadius:
                                            index === 0
                                            ?
                                            "22px"
                                            :
                                            "0px",

                                        borderTopRightRadius:
                                            index === options.length - 1
                                            ?
                                            "22px"
                                            :
                                            "0px",

                                        borderBottomRightRadius:
                                            index === options.length - 1
                                            ?
                                            "22px"
                                            :
                                            "0px"
                                    }}
                                    onClick={
                                        function()
                                        {
                                            setValue(
                                                option.label
                                            );
                                        }
                                    }
                                >

                                    {option.label}

                                </div>

                            );
                        }
                    )
                }

                <div
                    style={{
                        ...selectedPill,

                        background:
                            selectedOption.gradient,

                        width:
                            "calc("
                            +
                            segmentWidth
                            +
                            "% - 16px)",

                        left:
                            "calc("
                            +
                            (selectedIndex * segmentWidth)
                            +
                            "% + 8px)"
                    }}
                >

                    {value}

                </div>

            </div>

        </div>

    );
}

const container =
{
    padding: "18px",

    marginBottom: "16px",

    border: "1px solid #ececec",

    borderRadius: "12px",

    background: "#f7f9fc"
};

const titleStyle =
{
    fontWeight: "600",

    marginBottom: "14px",

    fontSize: "14px",

    color: "#333"
};

const scaleContainer =
{
    position: "relative",

    display: "flex",

    height: "44px",

    overflow: "visible"
};

const segment =
{
    flex: 1,

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    color: "rgba(255,255,255,0.85)",

    fontWeight: "600",

    fontSize: "12px",

    cursor: "pointer",

    userSelect: "none",

    transition: "all 0.25s ease"
};

const selectedPill =
{
    position: "absolute",

    top: "5px",

    bottom: "5px",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    color: "#fff",

    fontWeight: "700",

    borderRadius: "18px",

    transition:
        "all 0.25s ease",

		boxShadow:
		    "0 8px 20px rgba(0,0,0,0.40), " +
		    "0 16px 40px rgba(0,0,0,0.25), " +
		    "inset 0 1px 0 rgba(255,255,255,0.15), " +
		    "inset 0 -2px 4px rgba(0,0,0,0.15)",

    zIndex: 10
};